import store from '@/store';
import {
  VuexModule, Module, Mutation, Action, getModule,
} from 'vuex-module-decorators';
import { Applicant } from '@/api/Workers';
import {
  NotepadCompany,
  NotepadItemType,
  NotepadJobs,
  addNotepadItem,
  cleanNotepad,
  getNotepadApplicantsItems,
  getNotepadCompanyItems,
  getNotepadJobsItems,
  removeNotepadItem, getNotepadCoursesItems,
} from '@/api/Notepad';

export interface INotebookState {
  notebookJobs: NotepadJobs[]
  notebookWorkers: Applicant[]
  notebookCompany: NotepadCompany[]
  notebookCourses: any[]
}

@Module({ dynamic: true, store, name: 'NotebookModule' })
class Notebook extends VuexModule implements INotebookState {
  notebookJobs: NotepadJobs[] = JSON.parse(localStorage.getItem('notebook_jobs') || '[]');

  notebookWorkers: Applicant[] = JSON.parse(localStorage.getItem('notebook_workers') || '[]');

  notebookCompany: NotepadCompany[] = JSON.parse(localStorage.getItem('notebook_company') || '[]');

  notebookCourses: any[] = JSON.parse(localStorage.getItem('notebook_courses') || '[]');

  @Mutation
  SET_NOTEBOOK_JOBS(payload: NotepadJobs[]) {
    this.notebookJobs = payload;
  }

  @Mutation
  SET_NOTEBOOK_WORKERS(payload: Applicant[]) {
    this.notebookWorkers = payload;
  }

  @Mutation
  SET_NOTEBOOK_COMPANY(payload: NotepadCompany[]) {
    this.notebookCompany = payload;
  }

  @Mutation
  SET_NOTEBOOK_COURSES(payload: any[]) {
    this.notebookCourses = payload;
  }

  @Mutation
  DELETE_ALL_NOTEBOOK_NOTES() {
    this.notebookJobs = [];
    this.notebookWorkers = [];
    this.notebookCompany = [];
    this.notebookCourses = [];

    localStorage.setItem('notebook_jobs', JSON.stringify([]));
    localStorage.setItem('notebook_courses', JSON.stringify([]));
    localStorage.setItem('notebook_workers', JSON.stringify([]));
  }

  // Applicant Notepad
  @Action({ rawError: true })
  async getApplicantNotebookData(): Promise<void> {
    try {
      await this.getNotebookJobsData();
      await this.getNotebookCompaniesData();
    } catch (error) {
      // eslint-disable-next-line
      console.log(error);
      throw error;
    }
  }
  // Applicant Notepad end

  // Company Notepad
  @Action({ rawError: true })
  async getCompanyNotebookData(): Promise<void> {
    try {
      await this.getNotebookApplicantsData();
    } catch (error) {
      // eslint-disable-next-line
      console.log(error);
      throw error;
    }
  }
  // Company Notepad end

  // Consultant Notepad
  @Action({ rawError: true })
  async getConsultantNotebookData(): Promise<void> {
    try {
      await this.getNotebookJobsData();
      await this.getNotebookApplicantsData();
    } catch (error) {
      // eslint-disable-next-line
      console.log(error);
      throw error;
    }
  }
  // Consultant Notepad end

  @Action({ rawError: true })
  async getNotebookJobsData(): Promise<void> {
    try {
      const request = await getNotepadJobsItems();
      this.SET_NOTEBOOK_JOBS(request.records);
    } catch (error) {
      // eslint-disable-next-line
      console.log(error);
      throw error;
    }
  }

  @Action({ rawError: true })
  async getNotebookApplicantsData(): Promise<void> {
    try {
      const request = await getNotepadApplicantsItems();
      this.SET_NOTEBOOK_WORKERS(request.records);
    } catch (error) {
      // eslint-disable-next-line
      console.log(error);
      throw error;
    }
  }

  @Action({ rawError: true })
  async getNotebookCompaniesData(): Promise<void> {
    try {
      const request = await getNotepadCompanyItems();
      this.SET_NOTEBOOK_COMPANY(request.records);
    } catch (error) {
      // eslint-disable-next-line
      console.log(error);
      throw error;
    }
  }

  @Action({ rawError: true })
  async getNotebookCoursesData(): Promise<void> {
    try {
      const request = await getNotepadCoursesItems();
      this.SET_NOTEBOOK_COURSES(request.records);
    } catch (error) {
      // eslint-disable-next-line
      console.log(error);
      throw error;
    }
  }

  @Action({ rawError: true })
  async toogleNotepadItem(data: { item_id: number, isMarked: boolean, type: NotepadItemType }): Promise<void> {
    try {
      if (data.isMarked) {
        await removeNotepadItem(data.type, data.item_id);
      } else {
        await addNotepadItem(data.type, data.item_id);
      }
      switch (data.type) {
        case 'job':
          await this.getNotebookJobsData();
          break;
        case 'applicant':
          await this.getNotebookApplicantsData();
          break;
        case 'company':
          await this.getNotebookCompaniesData();
          break;
        case 'courses':
          await this.getNotebookCoursesData();
          break;
        default:
          break;
      }
    } catch (error) {
      // eslint-disable-next-line
      console.log(error);
      throw error;
    }
  }

  // JobNotepad Local
  @Action({ rawError: true })
  setJobNotepadItemLocal(data: {
    isMarked: boolean
    id: number
    position: string
    location: string
    lastdate: string
    company_name: string
    shortview: string
  }) {
    if (data.isMarked) {
      this.removeJobNotepadItemLocal({ id: data.id });
    } else {
      this.notebookJobs.push({
        id: data.id,
        position: data.position,
        location: data.location,
        lastdate: data.lastdate,
        company_name: data.company_name,
        shortview: data.shortview,
      });
      localStorage.setItem('notebook_jobs', JSON.stringify(this.notebookJobs));
    }
  }

  @Action({ rawError: true })
  removeJobNotepadItemLocal(data: {id: number}) {
    const jobs = this.notebookJobs.filter((val: any) => val.id !== data.id);
    this.SET_NOTEBOOK_JOBS(jobs);
    localStorage.setItem('notebook_jobs', JSON.stringify(this.notebookJobs));
  }
  // JobNotepad Local

  // notebookWorkers Local
  @Action({ rawError: true })
  setWorkerNotepadItemLocal(data: {
    isMarked: boolean
    id: number
    position: string
    position_keywords: string
    locations: string
    professions: string
    availability: string
    last_modified: string
    reg_date: string
    salary_hour: number
    salary_year: number
  }) {
    if (data.isMarked) {
      this.removeWorkerNotepadItemLocal({ id: data.id });
    } else {
      this.notebookWorkers.push({
        id: data.id,
        position: data.position,
        position_keywords: data.position_keywords,
        locations: data.locations,
        professions: data.professions,
        availability: data.availability,
        last_modified: data.last_modified,
        reg_date: data.reg_date,
        salary_hour: data.salary_hour,
        salary_year: data.salary_year,
      });
      localStorage.setItem('notebook_workers', JSON.stringify(this.notebookWorkers));
    }
  }

  @Action({ rawError: true })
  removeWorkerNotepadItemLocal(data: {id: number}) {
    const jobs = this.notebookWorkers.filter((val: any) => val.id !== data.id);
    this.SET_NOTEBOOK_WORKERS(jobs);
    localStorage.setItem('notebook_workers', JSON.stringify(this.notebookWorkers));
  }
  // notebookWorkers Local

  // notebookCourses Local
  @Action({ rawError: true })
  setCourseNotepadItemLocal(data: {
    isMarked: boolean
    id: number
    position: string
    location: string
    lastdate: string
    course_name: string
    url: string
    show_in_new_tab: boolean
  }) {
    if (data.isMarked) {
      this.removeCourseNotepadItemLocal({ id: data.id });
    } else {
      this.notebookCourses.push({
        id: data.id,
        position: data.position,
        location: data.location,
        lastdate: data.lastdate,
        course_name: data.course_name,
        url: data.url,
        show_in_new_tab: data.show_in_new_tab,
      });
      localStorage.setItem('notebook_courses', JSON.stringify(this.notebookCourses));
    }
  }

  @Action({ rawError: true })
  removeCourseNotepadItemLocal(data: {id: number}) {
    const jobs = this.notebookCourses.filter((val: any) => val.id !== data.id);
    this.SET_NOTEBOOK_COURSES(jobs);
    localStorage.setItem('notebook_courses', JSON.stringify(this.notebookCourses));
  }
  // notebookCourses Local

  // All
  @Action({ rawError: true })
  async DeleteAllNotebookNotes(userType: 'applicant' | 'company' | 'consultant' | 'courses') {
    try {
      switch (userType) {
        case 'applicant':
          await cleanNotepad('job');
          await cleanNotepad('company');
          break;
        case 'company':
          await cleanNotepad('applicant');
          break;
        case 'consultant':
          await cleanNotepad('job');
          await cleanNotepad('applicant');
          break;
        case 'courses':
          await cleanNotepad('courses');
          break;
        default:
          break;
      }
      this.DELETE_ALL_NOTEBOOK_NOTES();
    } catch (error) {
      // eslint-disable-next-line
      console.log(error);
      throw error;
    }
  }
}

export const NotebookModule = getModule(Notebook);
